import React, { FC } from 'react'
import styles from './components/CuratedDeals.module.scss'
import ArtworkPolaroidList from './components/ArtworkPolaroidList'
import Header from './components/Header'
import Banner from './components/Banner'
import Disclaimer from './components/Disclaimer'
import ListConnector, { ConnectorProps as ListProps } from './connectors/List'
import Blackout from './components/Blackout'

const CuratedDeals: FC<ListProps> = ({ isBlackout, artworks }) => {
  if (isBlackout || !artworks.length) {
    return <Blackout />
  }
  return (
    <div className={styles.grid}>
      <div className={styles.curatedDeals}>
        <Header />
        <Banner />
        <ArtworkPolaroidList />
        <Disclaimer />
      </div>
    </div>
  )
}

export default ListConnector(CuratedDeals)
